/* Veithdia · mejoras v1.5: nombres cortos en tarjetas y barra de compra fija */
(function () {
  'use strict';

  /* ---------- Tarjetas: "Caldera – Lentes de sol cuadrados polarizados" → Caldera / Cuadrados polarizados ---------- */
  var SEP = /\s+[–—-]\s+/;

  function cap(s) {
    return s ? s.charAt(0).toUpperCase() + s.slice(1) : s;
  }

  function splitTitle(full) {
    var parts = full.split(SEP);
    if (parts.length < 2) return null;
    var name = parts.shift().trim();
    var sub = parts.join(' – ').trim().replace(/^lentes de sol\s+/i, '').replace(/^lentes\s+/i, '');
    return { name: name, sub: cap(sub) };
  }

  function splitCards(root) {
    var links = (root || document).querySelectorAll('.card__heading a');
    for (var i = 0; i < links.length; i++) {
      var el = links[i];
      if (el.dataset.vtSplit) continue;
      var t = splitTitle(el.textContent.trim());
      el.dataset.vtSplit = '1';
      if (!t) continue;
      if (!el.getAttribute('aria-label')) el.setAttribute('aria-label', el.textContent.trim());
      el.textContent = '';
      var n = document.createElement('span');
      n.className = 'vt-name';
      n.textContent = t.name;
      var s = document.createElement('span');
      s.className = 'vt-sub';
      s.textContent = t.sub;
      el.appendChild(n);
      el.appendChild(s);
    }
  }

  var pending = false;
  function schedule() {
    if (pending) return;
    pending = true;
    requestAnimationFrame(function () {
      pending = false;
      splitCards(document);
    });
  }

  splitCards(document);
  document.addEventListener('DOMContentLoaded', function () {
    splitCards(document);
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        if (muts[i].addedNodes.length) {
          schedule();
          return;
        }
      }
    }).observe(document.body, { childList: true, subtree: true });
  });

  /* ---------- Barra de compra fija en la ficha ---------- */
  function initStickyAtc() {
    if (!document.body.classList.contains('template-product')) return;
    var info = document.querySelector('product-info[data-section*="__main"], product-info');
    if (!info) return;
    var mainBtn = info.querySelector('button[name="add"]');
    if (!mainBtn) return;

    var titleEl = info.querySelector('.product__title h1, .product__title');
    var fullTitle = titleEl ? titleEl.textContent.trim() : document.title;
    var t = splitTitle(fullTitle);
    var shortName = t ? t.name : fullTitle;

    var bar = document.createElement('div');
    bar.className = 'vt-sticky-atc';
    bar.setAttribute('aria-hidden', 'true');
    bar.innerHTML =
      '<img class="vt-sticky-atc__img" alt="" width="52" height="40">' +
      '<div class="vt-sticky-atc__info"><span class="vt-sticky-atc__name"></span><span class="vt-sticky-atc__meta"></span></div>' +
      '<button type="button" class="vt-sticky-atc__btn" tabindex="-1"></button>';
    document.body.appendChild(bar);

    var img = bar.querySelector('img');
    var nameEl = bar.querySelector('.vt-sticky-atc__name');
    var metaEl = bar.querySelector('.vt-sticky-atc__meta');
    var btn = bar.querySelector('button');

    function currentBtn() {
      return info.querySelector('button[name="add"]') || mainBtn;
    }

    function refresh() {
      var b = currentBtn();
      var priceEl = info.querySelector('.price .price-item--sale, .price .price-item--regular');
      var price = priceEl ? priceEl.textContent.trim() : '';
      var sel = info.querySelector('.vt-swatches [data-selected-value]');
      var color = sel ? sel.textContent.trim() : '';
      nameEl.textContent = shortName;
      metaEl.textContent = [color, price].filter(Boolean).join(' · ');
      var label = b.querySelector('span');
      btn.textContent = label ? label.textContent.trim() : b.textContent.trim();
      btn.disabled = b.disabled || b.getAttribute('aria-disabled') === 'true';
      var checked = info.querySelector('.vt-swatches input:checked + label img');
      var media = checked || info.querySelector('.product__media img');
      if (media) img.src = media.currentSrc || media.src;
    }

    btn.addEventListener('click', function () {
      var b = currentBtn();
      if (b && !b.disabled) b.click();
    });

    var visible = false;
    function setVisible(v) {
      if (v === visible) return;
      visible = v;
      if (v) refresh();
      bar.classList.toggle('is-visible', v);
      bar.setAttribute('aria-hidden', v ? 'false' : 'true');
    }

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        var e = entries[0];
        setVisible(!e.isIntersecting && e.boundingClientRect.top < 0);
      });
      io.observe(info.querySelector('.product-form__buttons') || mainBtn);
    }

    info.addEventListener('change', function () {
      setTimeout(refresh, 600);
    });
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, function () {
        setTimeout(refresh, 50);
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initStickyAtc);
  } else {
    initStickyAtc();
  }
})();
